import styled from "styled-components";

export const Page = styled.div`
  padding: 24px 32px 48px;
  max-width: 1280px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  margin: 0;
  color: #1f2937;
`;

export const Subtitle = styled.p`
  margin: 6px 0 20px;
  color: #6b7280;
  font-size: 14px;
`;

export const AttentionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: ${(p) => (p.$count > 0 ? "#991b1b" : "#065f46")};
  background: ${(p) => (p.$count > 0 ? "#fee2e2" : "#d1fae5")};
`;

export const Section = styled.section`
  margin-top: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  h2 {
    font-size: 13px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #374151;
    margin: 0;
  }
  button {
    font: inherit;
    font-size: 13px;
    color: #0c53bb;
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
  }
`;

export const Count = styled.span`
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 1px 8px;
`;

export const Empty = styled.div`
  padding: 14px 16px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 14px;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1.6fr) minmax(90px, 0.7fr) minmax(140px, 1fr) minmax(140px, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid ${(p) => (p.$attention ? "#fca5a5" : "#e5e7eb")};
  background: ${(p) => (p.$attention ? "#fff7f7" : "#fff")};
  border-radius: 8px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Name = styled.a`
  font-weight: 600;
  color: #0c53bb;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const Muted = styled.span`
  color: #6b7280;
  font-size: 13px;
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
  color: #1f2937;
  min-width: 0;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const Progress = styled.div`
  font-size: 14px;
  color: ${(p) => (p.$step === "done" ? "#065f46" : p.$step === "failed" ? "#991b1b" : "#1f2937")};
`;

export const Problem = styled.div`
  color: #991b1b;
  font-size: 13px;
  line-height: 1.4;
  ul {
    margin: 4px 0 0 16px;
    padding: 0;
    color: #7f1d1d;
  }
`;

export const FlagChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #92400e;
  background: #fef3c7;
  border-radius: 6px;
  padding: 2px 8px;
`;

export const ErrorBanner = styled.div`
  margin: 12px 0;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 14px;
`;

export const HiddenInput = styled.input`
  display: none;
`;
